import React from "react";
import LandingCard from "./components/LandingCard";
import Statistics from "./components/Statistics";

const Dashboard = () => {
  return (
    <section>
      <div className="row gy-4 mb-4 landing-cards">
        <div className="col-lg-3 col-md-6">
          <LandingCard {...{ title: "Properties", count: "310", icon: "buildings" }} />
        </div>
        <div className="col-lg-3 col-md-6">
          <LandingCard {...{ title: "Villas", count: "10", icon: "houses" }} />
        </div>
        <div className="col-lg-3 col-md-6">
          <LandingCard {...{ title: "Projects", count: "46", icon: "building" }} />
        </div>
        <div className="col-lg-3 col-md-6">
          <LandingCard {...{ title: "Customers", count: "30", icon: "people" }} />
        </div>
      </div>
      <div className="card">
        <h5>Statistics</h5>
        <Statistics />
      </div>
    </section>
  );
};

export default Dashboard;
